export default "__VITE_ASSET__B$tvtDys__"